import { defineComponent as a, openBlock as n, createBlock as r, unref as p, mergeProps as m, withCtx as s, createElementVNode as i } from "vue";
import { RevIcon as c } from "@ds/components/Icon";
const f = /* @__PURE__ */ a({
  name: "IconMediaPause",
  __name: "IconMediaPause",
  props: {
    size: {},
    alternativeText: {}
  },
  setup(t) {
    const o = t;
    return (u, e) => (n(), r(p(c), m(o, { "view-box": "0 0 24 24" }), {
      default: s(() => [...e[0] || (e[0] = [
        i("path", { d: "M8 8.5a1.5 1.5 0 1 1 3 0v7a1.5 1.5 0 0 1-3 0v-7m5 0a1.5 1.5 0 0 1 3 0v7a1.5 1.5 0 0 1-3 0v-7" }, null, -1)
      ])]),
      _: 1
    }, 16));
  }
});
export {
  f as default
};
